import { TCategories, TCategory } from '@/domain/Categories.domain';
import { URLs } from '@/service/constants/urls';
import { chunkArray } from '@/service/utils/chunkArray';
import { cn } from '@/service/utils/cn';
import { FormButton } from '@/ui/common/Buttons/FormButton';
import { SHOW_ALL_CATEGORY } from '../AttractionsContent';

type TCategoriesViewProps = {
    categories: TCategories;
    selectCategory: (category: TCategory) => void;
};

type TCategoryCart = {
    title: string;
    image: string;
    className?: string;
    onClick: () => void;
};

const MAX_SIZE = 4;
const STYLES_BY_COUNT: { [key: number]: string[] } = {
    1: ['md:col-span-4 md:row-span-2'],
    2: ['md:h-[496px] md:col-span-2 md:row-span-2', 'md:h-[496px] md:col-span-2 md:row-span-2'],
    3: ['md:h-[496px] md:col-span-2 md:row-span-2', 'md:col-span-2', 'md:col-span-2'],
    4: ['md:h-[496px] md:col-span-2 md:row-span-2', 'md:col-span-2'],
};

const CategoryCart = ({ title, image, className, onClick }: TCategoryCart) => {
    return (
        <div
            className={cn(
                'shadow-main relative h-60 cursor-pointer overflow-hidden rounded-2xl',
                className
            )}
            onClick={onClick}
        >
            <div className="absolute bottom-0 left-0 right-0 top-0 bg-gradient-category"></div>
            <img src={image} alt={title} className="h-full w-full object-cover" />
            <p className=" tx-heading-3 absolute bottom-11 left-3 mr-3 text-white">{title}</p>
            <FormButton
                label="View"
                variant="filledGray"
                className="tx-medium-semibold absolute bottom-4 right-3 h-6 w-20 from-gray-10 to-gray-9"
            />
        </div>
    );
};

const CategoriesBlock = ({ categories, selectCategory }: TCategoriesViewProps) => {
    return (
        <div className="mb-4 grid grid-cols-1 gap-4 md:grid-cols-4 md:grid-rows-2">
            {categories.map((category, index) => (
                <CategoryCart
                    title={category.title}
                    image={
                        category.has_image
                            ? `${URLs.image}/category_wr/${category.id}/center/${category.slug || 'wr'}.webp`
                            : '/img/EmptyImage.svg'
                    }
                    className={STYLES_BY_COUNT[categories.length][index]}
                    key={category.id}
                    onClick={() => selectCategory(category)}
                />
            ))}
        </div>
    );
};

export const CategoriesView = ({ categories, selectCategory }: TCategoriesViewProps) => {
    const chunks = chunkArray([...categories], MAX_SIZE);

    return (
        <div className="wrapper my-8">
            {chunks.map((list, index) => (
                <CategoriesBlock
                    categories={list}
                    selectCategory={selectCategory}
                    key={`${index}${list.length}`}
                />
            ))}
            <FormButton label="See All" onClick={() => selectCategory(SHOW_ALL_CATEGORY)} />
        </div>
    );
};
